import { str } from "./auditSummary/vocab";

/** Human labels for audit_log.action. Unknown codes pass through unchanged. */

export const AUDIT_ACTION_LABELS: Record<string, string> = {
  update: "Atualizou um perfil",
  profile_updated: "Atualizou um perfil",
  profile_lifecycle_mutation: "Mudou papel ou plano",
  profile_visibility_change: "Mudou a visibilidade do perfil",
  profile_unblocked: "Desbloqueou um membro",
  auto_deactivate: "Desativou o perfil automaticamente",
  crm_note_created: "Criou uma nota no CRM",
  crm_note_updated: "Editou uma nota no CRM",
  crm_note_deleted: "Apagou uma nota no CRM",
  interest_form_updated: "Atualizou um formulário de interesse",
  member_interest_added: "Adicionou um interesse",
  member_interest_removed: "Removeu um interesse",
  referral_updated: "Atualizou uma indicação",

  activity_created: "Criou uma atividade",
  activity_updated: "Atualizou uma atividade",
  activity_deleted: "Apagou uma atividade",
  "activity.cancelled": "Cancelou uma atividade",
  "referral_invite.presence_lot_cancelled": "Cancelou o convite de um convidado",
  "referral_invite.staff_resent": "Clube reenviou convite",
  "referral_invite.staff_seat_released": "Clube liberou vaga de convidado",
  "activity.capacity_repaired": "Vagas do evento recalculadas",
  activity_interests_synced: "Sincronizou interesses da atividade",
  event_created: "Criou um evento",
  event_updated: "Atualizou um evento",
  event_deleted: "Apagou um evento",
  event_interests_synced: "Sincronizou interesses do evento",
  event_reminder_created: "Criou um lembrete de evento",
  event_reminder_deleted: "Apagou um lembrete de evento",
  experience_created: "Criou uma experiência",
  experience_updated: "Atualizou uma experiência",
  experience_deleted: "Apagou uma experiência",
  experience_participant_updated: "Atualizou um participante",
  rsvp_updated: "Atualizou uma inscrição",
  rsvp_demoted_to_waitlist: "Moveu a inscrição para a fila",

  benefit_created: "Criou um benefício",
  benefit_updated: "Atualizou um benefício",
  benefit_deleted: "Apagou um benefício",
  benefit_reordered: "Reordenou benefícios",
  benefit_category_created: "Criou uma categoria de benefício",
  benefit_category_updated: "Atualizou uma categoria de benefício",
  benefit_category_deleted: "Apagou uma categoria de benefício",
  benefit_category_reordered: "Reordenou categorias de benefício",
  space_created: "Criou um espaço",
  space_updated: "Atualizou um espaço",
  space_deleted: "Apagou um espaço",
  space_amenity_created: "Criou uma amenidade",
  space_amenity_deleted: "Apagou uma amenidade",
  space_amenity_links_synced: "Sincronizou amenidades do espaço",
  space_type_created: "Criou um tipo de espaço",
  space_type_updated: "Atualizou um tipo de espaço",
  space_type_deleted: "Apagou um tipo de espaço",
  space_type_tier_discount_synced: "Sincronizou desconto do tipo de espaço",
  venue_created: "Criou um local",
  venue_updated: "Atualizou um local",
  venue_deleted: "Apagou um local",
  booking_updated: "Atualizou uma reserva",
  audience_rules_synced: "Sincronizou regras de público",
  refund_policies_synced: "Sincronizou política de reembolso",

  feed_post_created: "Publicou no News",
  feed_post_updated: "Atualizou um post do News",
  feed_post_deleted: "Apagou um post do News",
  feed_image_synced: "Sincronizou imagens do News",
  feed_posts_retained: "Manteve posts do News na exclusão",
  home_hero_set: "Atualizou os destaques da home",

  tier_created: "Criou um plano",
  tier_updated: "Atualizou um plano",
  tier_deleted: "Apagou um plano",
  tier_forms_published: "Publicou os formulários do plano",
  tier_forms_mirrored: "Espelhou as formas de pagamento do plano",
  tier_billing_option_deactivated: "Desativou uma forma de pagamento do plano",
  tier_billing_options_synced: "Sincronizou formas de cobrança do plano",
  tier_stripe_synced: "Sincronizou o plano na Stripe",
  membership_discount_granted: "Concedeu desconto ou pagamento fora do app",
  membership_discount_replaced: "Substituiu desconto ou pagamento fora do app",
  membership_discount_revoked: "Revogou desconto ou pagamento fora do app",
  subscription_discount_updated: "Atualizou desconto da assinatura",
  subscription_non_renewal_requested: "Pediu para não renovar",
  subscription_non_renewal_canceled: "Cancelou o pedido de não renovar",
  subscription_billing_option_change_requested: "Pediu para trocar a forma de pagamento do plano",
  subscription_invitation_closed_dead_payment: "Convite fechado: pagamento não concluído",
  subscription_invitation_closed_subscription_ended: "Convite de troca de plano fechado: assinatura encerrada",
  dunning_config_updated: "Atualizou a régua de cobrança",
  dunning_step_updated: "Atualizou um passo da régua",
  billing_snapshot_updated: "Atualizou um snapshot de faturamento",
  "invoice.retry_succeeded": "Retentativa de fatura deu certo",
  "invoice.retry_failed": "Retentativa de fatura falhou",
  stripe_webhook_orphan_subscription: "Webhook Stripe: assinatura órfã",
  subscription_tier_change_refused_by_contract_gate: "Troca de plano recusada: falta aceite do contrato",
  subscription_status_refused_by_contract_gate: "Reativação da assinatura recusada: falta aceite do contrato",
  tenant_stripe_connected: "Conectou a conta Stripe",
  tenant_stripe_connect_refused: "Recusou a conexão Stripe",
  "payment_method.attached": "Anexou um meio de pagamento",
  "payment_method.detached": "Removeu um meio de pagamento",
  "payment_method.set_default": "Definiu o meio de pagamento padrão",
  "payment_method.set_role": "Mudou o papel do cartão",
  "payment_method.saved_from_purchase": "Salvou o cartão usado na compra",
  "payment.declined": "Pagamento recusado",
  "activity_payment.previous_attempt_settled": "Resolveu a tentativa de pagamento anterior",
  "payment_method.detached_on_account_deletion": "Removeu meio de pagamento na exclusão da conta",
  payments_retained: "Manteve pagamentos na exclusão",
  renewal_reminder_rule_created: "Criou regra de lembrete de renovação",
  renewal_reminder_rule_updated: "Atualizou regra de lembrete de renovação",
  renewal_reminder_rule_deleted: "Apagou regra de lembrete de renovação",

  consent_granted: "Concedeu consentimento",
  consent_revoked: "Revogou consentimento",
  consent_ledger_granted: "Aceitou um documento",
  consent_ledger_revoked: "Revogou um aceite",
  consent_ledger_retained: "Manteve consentimento na exclusão",
  legal_document_created: "Criou um documento legal",
  legal_document_updated: "Atualizou um documento legal",
  legal_document_tier_linked: "Ligou um plano a um contrato",
  legal_document_tier_moved: "Moveu um plano para outro contrato",
  data_export: "Exportou dados",
  data_deletion_requested: "Pediu exclusão de dados",
  data_deletion_canceled: "Cancelou a exclusão de dados",
  data_deletion_staff_forced: "Forçou a exclusão de dados",
  data_deletion_staff_executed: "Executou a exclusão de dados",
  terms_acceptances_retained: "Manteve aceites de termos na exclusão",

  communication_created: "Enviou uma comunicação",
  communication_template_created: "Criou um modelo de comunicação",
  communication_template_deleted: "Apagou um modelo de comunicação",
  notification_bulk_sent: "Enviou notificações em lote",
  interest_created: "Criou um interesse",
  interest_updated: "Atualizou um interesse",
  interest_deleted: "Apagou um interesse",
  interest_category_created: "Criou uma categoria de interesse",
  interest_category_updated: "Atualizou uma categoria de interesse",
  interest_category_deleted: "Apagou uma categoria de interesse",
  menu_category_created: "Criou uma categoria do cardápio",
  menu_category_updated: "Atualizou uma categoria do cardápio",
  menu_category_deleted: "Apagou uma categoria do cardápio",
  menu_item_created: "Criou um item do cardápio",
  menu_item_updated: "Atualizou um item do cardápio",
  menu_item_deleted: "Apagou um item do cardápio",
  staff_role_created: "Criou um papel de staff",
  staff_role_updated: "Atualizou um papel de staff",
  staff_role_deleted: "Apagou um papel de staff",
  staff_venue_coverage_synced: "Atualizou os locais que um staff cobre",
  system_setting_upserted: "Alterou uma configuração do sistema",
  tenant_settings_updated: "Atualizou configurações do clube",
  affinity_score_deleted: "Apagou um score de afinidade",
};

/** Own keys only: a code like "constructor" must not read Object.prototype. */
function ownLabel(map: Record<string, string>, action: string): string | undefined {
  return Object.prototype.hasOwnProperty.call(map, action) ? map[action] : undefined;
}

export function labelForAuditAction(action: string): string {
  return ownLabel(AUDIT_ACTION_LABELS, action) ?? action;
}

/** What the caller resolved outside the row, e.g. the grant's last day via resolve_audit_targets. */
export interface AuditRowLabelContext {
  /** courtesy_last_day of the revoked grant, "YYYY-MM-DD"; null or absent when unknown. */
  grantLastDay?: string | null;
}

const DATED_GRANT_LABELS: Record<string, string> = {
  membership_discount_granted: "Concedeu pagamento fora do app",
  membership_discount_replaced: "Substituiu pagamento fora do app",
};

const PLAIN_DISCOUNT_LABELS: Record<string, string> = {
  membership_discount_granted: "Concedeu desconto",
  membership_discount_replaced: "Substituiu desconto",
};

function hasDay(value: unknown): value is string {
  return typeof value === "string" && value.trim() !== "";
}

/**
 * Row-level label (KTD6). A dated grant means the member paid outside the app
 * (KLUB-247). A revoke row does not carry the date, so it is refined only when
 * the caller resolved it; otherwise it keeps the neutral label, because a
 * missing date does not prove the grant was a plain discount.
 */
export function labelForAuditRow(action: string, details: unknown, context?: AuditRowLabelContext): string {
  const dated = ownLabel(DATED_GRANT_LABELS, action);
  const plain = ownLabel(PLAIN_DISCOUNT_LABELS, action);
  if (dated !== undefined && plain !== undefined) {
    return str(details, "courtesy_last_day") !== null ? dated : plain;
  }
  if (action === "membership_discount_revoked" && hasDay(context?.grantLastDay)) {
    return "Revogou pagamento fora do app";
  }
  return labelForAuditAction(action);
}
